export const isOnline = () => {
    return navigator.onLine; // Check if the browser is online
};
